import React, { FC } from 'react';

interface ProfilePictureProps {
  readonly url: string;
}

export const UserProfilePicture: FC<ProfilePictureProps> = ({ url }) => {
  return (
    <img
      referrerPolicy="no-referrer"
      src={url}
      style={{ float: 'left', paddingRight: '10px', maxWidth: '64px' }}
    />
  );
};
